export default function formatParticipants(formValues, qty) {
  let participants = [];
  for (let i = 0; i < qty; i++) {
    let participantForm = {};
    for (let key in formValues) {
      if (key.includes(`-${i}`)) {
        let newKey = key.split("-");
        newKey.pop();
        newKey = newKey.join("_");

        let value = formValues[key];
        // normalize phone code
        if (newKey === "customer_phcode" && value) {
          value = value.startsWith("+") ? value : `+${value}`;
        }

        participantForm[newKey] = value;
      }
    }
    participants.push(participantForm);
  }
  return participants;
}
